import { Box, Stack, Typography } from '@mui/material';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import SearchBox from '../../../core-components/theme/components/Searchbox/Searchbox';
import QueryErrorBoundary from '../../../globalComponents/ErrorBoundary';
import Loader from '../../../globalComponents/loader/DPLoader';
import { useDebouncedSearchParam } from '../../../hooks/useDebouncedSearchParam';
import AddLogbookTemplateButtonAndModal from './AddLogbookTemplateButtonAndModal';
import LogbookTemplateTable from './LogBookTemplateTable';

function LogbookTemplatesContent() {
    const { t } = useTranslation();
    const { searchValue, inputRef, handleSearch } = useDebouncedSearchParam();

    return (
        <>
            <SearchBox
                id='search'
                placeholder={t('logbook.templates.searchPlaceholder', 'Search logbook templates')}
                onSearch={handleSearch}
                onClear={() => handleSearch('')}
                onChange={(e) => handleSearch(e.target.value)}
                ref={inputRef}
                defaultValue={searchValue}
            />

            <Box width="100%" height='80%'>
                <QueryErrorBoundary>
                    <Suspense fallback={<Loader height="100%" />}>
                        <LogbookTemplateTable
                            searchString={searchValue}
                        />
                    </Suspense>
                </QueryErrorBoundary>
            </Box>
        </>
    );
}

export default function LogbookTemplates() {
    const { t } = useTranslation();
    return (
        <Box height='100%'>
            <Stack height='100%' direction="column" spacing={3}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant='title'>{t('logbook.templates.title', 'Logbook Templates')}</Typography>
                    <AddLogbookTemplateButtonAndModal />
                </Stack>

                <LogbookTemplatesContent />
            </Stack>
        </Box>
    );
}